import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as amUtils from "src/utils/amUtils";
import * as Enums from "src/utils/enums";
import FormInput from "src/pages/components/AMFormInput";
import {
  Box,
  Alert,
  IconButton,
  Button,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Divider as MuiDivider,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  Close as CloseIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  ContentCopy as CopyIcon,
  Print as PrintIcon,
} from "@mui/icons-material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import useCurrentPath from "src/hooks/useCurrentPath";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { preLoadFormDetails } from "src/services/generalService";
import ReportViewer from "src/pages/ReportViewer/index";
import {
  getSelectedCompany,
  getSelectedBranch,
} from "src/services/httpService";
import { getCaption } from "src/utils/dictionary";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Divider = styled(MuiDivider)(spacing);

const useForm = ({
  menuItemCode,
  nextCodeField,
  getNextCodeFunc,
  getByIdFunc,
  saveFunction,
  deleteFunction,
  isSubForm,
  subFormControls,
  defaulteValuesFunc,
  ...rest
}) => {
  let { id: urlId } = useParams();
  const { pathname } = useCurrentPath();
  let navigate = useNavigate();

  //#region Initial state
  const [preLoaded, setPreLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [indexColumns, setIndexColumns] = useState([]);
  const [filterControls, setFilterControls] = useState([]);
  const [formControls, setFormControls] = useState({});
  const [formSchema, setFormSchema] = useState({});
  const [formPrintOuts, setFormPrintOuts] = useState([]);
  const [reportViewerKey, setReportViewerKey] = useState(0);
  const [openReportViewer, setOpenReportViewer] = useState(false);
  const [openExitConfirm, setOpenExitConfirm] = useState(false);
  const [openNewConfirm, setOpenNewConfirm] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [reportFilterCriteria, setReportFilterCriteria] = useState({});
  const [autoRunReportId, setAutoRunReportId] = useState(null);

  const [subFormControlsState, setsubFormControlsState] = useState(
    subFormControls || {}
  );
  const [formData, setFormData] = useState({ id: urlId });
  const [copiedData, setCopiedData] = useState({});

  const [errors, setErrors] = useState({});
  //#endregion

  const validate = (fieldName, value) => {
    const err = amUtils.validate(formSchema, errors, fieldName, value);
    setErrors({ ...err });
  };

  const handleSetState = (newState) => {
    //setFormData(newState);
    setFormData((state) => ({ ...state, ...newState }));
  };

  const handleSetFullState = (newState) => {
    setFormData(newState);
  };

  const exitPage = () => {
    setFormData({});
    navigate(pathname.replace(`/${formData.id}/`, ""));
  };

  const handleCopyForm = async () => {
    setIsLoading(true);
    const nextCode = await getNextCodeFunc();
    const copiedData = JSON.parse(JSON.stringify(formData));
    copiedData[nextCodeField] = nextCode;
     if (copiedData) {
      delete copiedData.id;
      delete copiedData.ID;
      delete copiedData.Id;
      delete copiedData.iD;
    }
    setCopiedData(copiedData);

    const newUrl =
      pathname.substring(0, pathname.lastIndexOf(urlId)) +
      pathname.substring(pathname.lastIndexOf(urlId)).replace(urlId, "add");
    navigate(newUrl);

    setIsLoading(false);
  };

  const handleAddNew = async () => {
    setCopiedData({});
    setFormData({ id: "add" });
    const newUrl =
      pathname.substring(0, pathname.lastIndexOf(urlId)) +
      pathname.substring(pathname.lastIndexOf(urlId)).replace(urlId, "add");
    navigate(newUrl);
  };

  const getAndBindData = async () => {
    setIsLoading(true);
    const data = await getByIdFunc(formData.id);
    //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    const newState = { ...data, id: formData.id };
    setFormData(newState);
    setIsLoading(false);
  };

  const vaLidateFormData = () => {
    const errors = amUtils.validateForm(formData, formSchema);
    if (errors && Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    }
    if (isSubmitting) {
      toast.error(getCaption("please_wait"));
      return false;
    }
    return true;
  };

  const handleSaveForm = async (saveType) => {
    try {
      if (!vaLidateFormData()) return false;
      setIsSubmitting(true);
      const payLoadData = JSON.parse(JSON.stringify(formData));
      if (payLoadData.id.toString().toLowerCase() === "add".toLowerCase()) {
        delete payLoadData.id;
      }
      const data = await saveFunction(menuItemCode, payLoadData);
      if (!data) {
        setIsSubmitting(false);
        return false;
      }
      //if (!isSubForm) {
      if (formData.id.toString().toLowerCase() === "add".toLowerCase()) {
        var newUrl =
          pathname.substring(0, pathname.lastIndexOf(urlId)) +
          pathname
            .substring(pathname.lastIndexOf(urlId))
            .replace(urlId, data.id);
        navigate(newUrl);
      } else {
        await getAndBindData();
      }
      //}

      setIsSubmitting(false);
      toast.success(getCaption("save_done"));
      return true;
      // switch (saveType) {
      //   case "saveandnew":
      //     navigateTo("create");
      //     this.clearForm();
      //     break;
      //   case "saveandcopy":
      //     this.copyForm();
      //     break;
      //   default:
      //     navigateTo();
      //     break;
      // }
    } catch (err) {
      setIsSubmitting(false);
      toast.error(
        err.response && err.response.data ? err.response.data : err.message
      );
      return false;
    }
  };

  const handleDeleteRecord = () => {
    if (isSubmitting) {
      toast.error(getCaption("please_wait"));
      return;
    }

    setOpenDeleteConfirm(true);
  };

  const confirmDeleteRecord = async () => {
    try {
      setIsSubmitting(true);

      const payLoadData = JSON.parse(JSON.stringify(formData));
      if (payLoadData.id.toString().toLowerCase() === "add") {
        setIsSubmitting(false);
        return;
      }

      await deleteFunction(menuItemCode, payLoadData);
      var newUrl = pathname.substring(0, pathname.lastIndexOf(urlId));
      navigate(newUrl);

      setIsSubmitting(false);
      toast.success(getCaption("delete_done"));
    } catch (err) {
      setIsSubmitting(false);
      toast.error(
        err.response && err.response.data ? err.response.data : err.message
      );
    }
  };

  const handlePrintRecord = async (reportId, criteria) => {
    if (isSubmitting) {
      toast.error(getCaption("please_wait"));
      return;
    }

    try {
      setIsSubmitting(true);
      const rCriteria = {};
      if (criteria.includes("#")) {
        const arr = criteria.split(",");
        arr.forEach((element) => {
          const arr2 = element.split(":");
          if (arr2 && arr2.length && arr2.length === 2) {
            if (arr2[1].trim().startsWith("#")) {
              rCriteria[arr2[0].trim()] =
                formData[arr2[1].trim().replace("#", "")];
            } else {
              rCriteria[arr2[0].trim()] = arr2[1].trim();
            }
          }
        });
      }

      setReportFilterCriteria(rCriteria);
      setAutoRunReportId(reportId);
      setOpenReportViewer(true);
      setReportViewerKey(Math.random());
      // const payLoadData = JSON.parse(JSON.stringify(formData));
      // if (payLoadData.id.toLowerCase() === "add") {
      //   return;
      // }

      // const data = await deleteFunction(menuItemCode, payLoadData);
      // var newUrl = pathname.substring(0, pathname.lastIndexOf(urlId));
      // navigate(newUrl);

      setIsSubmitting(false);
    } catch (err) {
      setIsSubmitting(false);
      toast.error(
        err.response && err.response.data ? err.response.data : err.message
      );
    }
  };

  const getFormDefaultValus = () => {
    // TODO >> get from formConmtrols
    // const obj = { operationType: 1, trxDate: "2022-08-26" };
    let d = {};
    if (typeof defaulteValuesFunc === "function") {
      d = defaulteValuesFunc();
    }

    d = d || {};
    const obj = { ...d };
    return obj;
  };

  //#region Events
  useEffect(() => {
    if (!isSubForm) return;
    setFormControls(subFormControls);
  }, [isSubForm, Object.keys(subFormControlsState).length]);

  /*OnChange Url > it happens after saving successfully */
  useEffect(() => {
    if (isSubForm) return;

    if (copiedData && Object.keys(copiedData).length) {
      setFormData({ ...copiedData, id: urlId });
      setCopiedData({});
    } else {
      setFormData({ id: urlId });
    }
  }, [urlId]);

  /*PreLoad Event*/
  useEffect(() => {
    if (isSubForm) {
      const schema = amUtils.createFormSchema(subFormControls);
      setFormSchema(schema);
      return;
    }
    //PreLoad Event
    //Get Form Controls
    // set indexcolumns, filter controls,Form Controls
    (async () => {
      const { data } = await preLoadFormDetails(menuItemCode);
      const controls = data.formControls;
      if (controls) {
        setIndexColumns(amUtils.createIndexColumns(controls));
        setFilterControls(controls.filter((x) => x.section === 4));
        const formControlsAsObj = amUtils.mapFormControlsToObject(
          controls.filter((x) => x.section === 1 || x.section === 2)
        );
        setFormControls(formControlsAsObj);

        const schema = amUtils.createFormSchema(
          amUtils.mapFormControlsToObject(
            controls.filter((x) => x.section === 1)
          )
        );
        setFormSchema(schema);
      }
      setFormPrintOuts(data.formPrintOuts || []);
      setPreLoaded(true);
      setPageTitle(data.pageTitle);
    })();
  }, [menuItemCode, isSubForm]);

  //After Pre Loaded
  useEffect(() => {
    if (isSubForm) return;
    //After Pre Loaded
    if (!preLoaded) return;

    (async () => {
      if (formData.id && formData.id.toString().toLowerCase() === "add") {
        try {
          const defaultValuesObj = getFormDefaultValus();
          const nextCode = await getNextCodeFunc();
          const newState = { ...formData, ...defaultValuesObj };
          newState[nextCodeField] = nextCode;
          setFormData(newState);
        } catch (error) {
          console.log(error.message);
        }
      } else if (formData.id) {
        try {
          await getAndBindData();
        } catch (error) {
          console.log(error.message);
          if (error.response && error.response.status === 404) {
            toast.error(getCaption("not_found"));
            exitPage();
          } else {
            toast.error(error.message);
            exitPage();
          }
        }
      } else {
        exitPage();
      }
    })();
  }, [preLoaded, formData.id]);
  //#endregion

  //#region handleing Events

  //#endregion handleing Events
  const handleSelectedIndexChange = (event, value, reason, fieldName) => {
    // const errors = { ...this.state.errors };
    // const errorMessage = this.validateProperty({
    //   name: fieldName,
    //   value: value && value.valueField,
    // });
    // if (errorMessage) errors[fieldName] = errorMessage;
    // else delete errors[fieldName];
    //const data = { ...this.state.data };
    //setVal(value);
    //this.setState({ data, errors });
    const val = value ? value.valueField : value;
    validate(fieldName, val);
    setFormData((state) => ({ ...state, [fieldName]: val }));
  };
  const handleChange = (e) => {
    try {
      //TODO>> THROW ERROR IF DATEPICKER
      e.persist();
    } catch {}
    if (e.target.type && e.target.type === Enums.ControlType.CheckBox) {
      setFormData((state) => ({ ...state, [e.target.name]: e.target.checked }));
    } else {
      validate(e.target.name, e.target.value);
      setFormData((state) => ({ ...state, [e.target.name]: e.target.value }));
    }
  };
  //#region render Functions
  const renderFormHeaderButtons = (withOutAddButton = false) => {
    const id = formData.id;
    return (
      <>
        {id === undefined &&!withOutAddButton && (
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(pathname + "add")}
            >
              {getCaption("new")}
              <AddIcon />
               {/* {pageTitle} */}
            </Button>
          </div>
        )}
        {id !== undefined && (
          <>
            <Button
              mr={2}
              size="small"
              onClick={() => setOpenExitConfirm(true)}
              disabled={isSubmitting}
              color="warning"
            >
              <CloseIcon />
              {getCaption("exit")}
            </Button>
            <Button
              mr={2}
              size="small"
              disabled={Object.keys(errors).length > 0 || isSubmitting}
              onClick={() => handleSaveForm()}
            >
              <SaveIcon />
              {id === "add" ? getCaption("save") : getCaption("update")}
            </Button>

            {!!id &&
              id.toString().toLowerCase() !== "add" &&
              formPrintOuts.map((x) => (
                <Button
                  key={Math.random()}
                  mr={2}
                  size="small"
                  disabled={isSubmitting}
                  onClick={() => handlePrintRecord(x.reportId, x.criteria)}
                >
                  <PrintIcon />
                  {x.name}
                </Button>
              ))}

            {!!id && id.toString().toLowerCase() !== "add" && (
              <Button
                mr={2}
                size="small"
                disabled={isSubmitting}
                onClick={() => handleDeleteRecord()}
                color="error"
              >
                <DeleteIcon />
                {getCaption("delete")}
              </Button>
            )}
            <Button mr={2} size="small" onClick={handleCopyForm}>
              <CopyIcon />
              {getCaption("copy")}&nbsp;
            </Button>
            {!!id && id.toString().toLowerCase() !== "add" && (
              <Button mr={2} size="small" onClick={() => setOpenNewConfirm(true)}>
                <AddIcon />
                {getCaption("new")}
              </Button>
            )}
          </>
        )}
      </>
    );
  };

  const renderFormHeader = (withOutAddButton = false) => {
    const selectedCompany = getSelectedCompany();
    const selectedBranch = getSelectedBranch();
    if (!selectedCompany || !selectedBranch) {
      return (
        <Box mb={3}>
          <Alert
            mb={4}
            severity="error"
            action={
              <IconButton
                aria-label={getCaption("close")}
                color="inherit"
                size="small"
                onClick={() => {
                  setErrors({});
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <ul style={{ paddingLeft: 10 }}>
              <li key={Math.random()}>
                {getCaption("please_select_company_and_branch")}
              </li>
            </ul>
          </Alert>
        </Box>
      );
    }

    return (
      <>
        <Grid justifyContent="space-between" container spacing={10}>
          <Helmet title={pageTitle} />
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link to="/">{getCaption("dashboard")}</Link>
              <Link to="/">{getCaption("pages")}</Link>
              <Typography>{pageTitle}</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item alignContent="right" justifyContent="right">
            {renderFormHeaderButtons(withOutAddButton)}
          </Grid>
        </Grid>
        <Divider my={2} />
        {(isSubmitting || isLoading) && <LinearProgress my={2} />}
        {renderErrorsSection()}

        <Dialog open={openExitConfirm} onClose={() => setOpenExitConfirm(false)}>
          <DialogTitle>{getCaption("warning")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {getCaption("lose_unsaved_data_leave")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenExitConfirm(false)} variant="outlined">
              {getCaption("cancel")}
            </Button>
            <Button
              onClick={() => {
                setOpenExitConfirm(false);
                exitPage();
              }}
              color="warning"
              variant="contained"
            >
              {getCaption("exit")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openNewConfirm} onClose={() => setOpenNewConfirm(false)}>
          <DialogTitle>{getCaption("warning")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {getCaption("lose_unsaved_data_new_record")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNewConfirm(false)} variant="outlined">
              {getCaption("cancel")}
            </Button>
            <Button
              onClick={() => {
                setOpenNewConfirm(false);
                handleAddNew();
              }}
              color="warning"
              variant="contained"
            >
              {getCaption("new")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteConfirm}
          onClose={() => setOpenDeleteConfirm(false)}
        >
          <DialogTitle>{getCaption("confirm_delete")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {getCaption("delete_record_cannot_undo")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteConfirm(false)} variant="outlined">
              {getCaption("cancel")}
            </Button>
            <Button
              onClick={() => {
                setOpenDeleteConfirm(false);
                confirmDeleteRecord();
              }}
              color="error"
              variant="contained"
            >
              {getCaption("delete")}
            </Button>
          </DialogActions>
        </Dialog>

        {formPrintOuts && !!formPrintOuts.length && openReportViewer && (
          <ReportViewer
            key={reportViewerKey}
            autoRun={true}
            onCloseViewer={(x) => setOpenReportViewer(x)}
            filterCriteria={reportFilterCriteria}
            autoRunReportId={autoRunReportId}
            menuItemCode={menuItemCode}
          />
        )}
      </>
    );
  };
  const renderFormInput = (
    fieldName,
    controlType,
    inputProps,
    gridItemProps,
    options
  ) => {
    if (formControls[fieldName] && formControls[fieldName].isHidden) {
      return;
    }

    const gridProps = gridItemProps || {};
    if (controlType === Enums.ControlType.CheckBox) {
      return (
        <FormInput
          type={controlType}
          name={fieldName}
          control={formControls[fieldName]}
          checked={!!formData[fieldName] || false}
          onChange={handleChange}
          errorMsg={errors[fieldName]}
          gridItemProps={gridProps}
          key={
            formControls[fieldName]
              ? formControls[fieldName].controlName
              : fieldName
          }
        />
      );
    }
    return (
      <FormInput
        type={controlType}
        name={fieldName}
        control={formControls[fieldName]}
        options={options}
        onChange={
          controlType === Enums.ControlType.AutoSearch ||
          controlType === Enums.ControlType.AutoComplete
            ? handleSelectedIndexChange
            : handleChange
        }
        value={
          formData[fieldName] ||
          (controlType === Enums.ControlType.DatePicker
            ? null
            : formData[fieldName] !== 0
            ? ""
            : formData[fieldName])
        }
        errorMsg={errors[fieldName]}
        gridItemProps={gridProps}
        {...inputProps}
        key={
          formControls[fieldName]
            ? formControls[fieldName].controlName
            : fieldName
        }
      />
    );
  };

  const renderErrorsSection = () => {
    if (Object.keys(errors).length > 0) {
      return (
        <Box mb={3}>
          <Alert
            mb={4}
            severity="error"
            action={
              <IconButton
                aria-label={getCaption("close")}
                color="inherit"
                size="small"
                onClick={() => {
                  setErrors({});
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <ul style={{ paddingLeft: 10 }}>
              {Object.keys(errors).map((x) => (
                <li key={Math.random()}>{errors[x]}</li>
              ))}
            </ul>
          </Alert>
        </Box>
      );
    }
  };
  //#endRegion

  return {
    state: formData,
    errors,
    handleSetState,
    handleSetFullState,
    handleChange,
    handleSelectedIndexChange,
    formControls,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
    vaLidateFormData,
    filterControls,
    renderErrorsSection,
  };
};
export default useForm;
